export enum Ui2DatePickerType {
  QuickOptionsPicker = 'quickOptionsPicker',
  RangePicker = 'rangePicker',
  SinglePicker = 'singlePicker'
}

export const CUSTOM_RANGE = 'customRange';

export interface IMyDate {
  year: number;
  month: number;
  day: number;
}

export interface Ui2DatePickerModel {
  epoc?: number; // Begin timestamp
  endEpoc?: number; // End timestamp
  date?: IMyDate;
  jsdate?: Date;
  beginJsDate?: Date;
  endJsDate?: Date;
  beginEpoc?: number;
  formatted?: string;
  beginDate?: IMyDate;
  endDate?: IMyDate;
}

export interface Ui2QuickSelectOption {
  id?: string;
  label: string;
  msFromNow?: number; // milliseconds from now,
  onSelect?: () => any; // intentional... we wan to keep it flexible
}

export interface Ui2DatepickerRange {
  start: Date;
  end: Date;
}
